<template>
  <div class="intro-summary-content" id="identidade-verbal-resumindo-introducao" data-search-anchor>
    <div>
      <h1 class="intro-summary-text">{{ introSummaryText }}</h1>
    </div> 
    <div
      class="intro-summary-card-item"
      :style="{ backgroundImage: `url(${introSummaryImageSrc})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import SummaryPageMixin from '@/mixins/summary-page-mixin'
import { SummaryPageStore } from '@/store/verbal-identity-page/summary-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class SummaryIntroSection extends Mixins(SummaryPageMixin) {
  summaryPageStore: PageStoreContract = getModule(SummaryPageStore, this.$store)

  get introSummaryText(): string {
    return this.getElementText(1, 0)
  }

  get introSummaryImageSrc(): string {
    return this.getElementMedia(1, 0)
  }

   async getSummaryPage(): Promise<void> {
    await this.summaryPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.summaryPageStore.isLoading) {
      await this.getSummaryPage()
    }
  }
}
</script>

<style lang="scss">
.intro-summary-content {
  display: grid;
  grid-template-columns: 50% 50%;
  width: 100%;
  max-width: 1032px;  
}

.intro-summary-text {
  font-size: 40px;
  font-weight: 400;
  line-height: 44px;
  letter-spacing: -0.01em;
  text-align: left;
  margin: 0;
  white-space: pre;
}

.intro-summary-card-item {
  position: relative;
  border-radius: 12px;
  max-width: 600px;
  width: 100%;
  height: 600px;  
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  overflow: hidden;
}

</style>

